import { render, staticRenderFns } from "./FissionRedEnvelope.vue?vue&type=template&id=c7ced418&scoped=true"
import script from "./FissionRedEnvelope.vue?vue&type=script&lang=js"
export * from "./FissionRedEnvelope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ced418",
  null
  
)

export default component.exports